module.exports = __webpack_public_path__ + "img/stc.8b7232a4.svg";